<div class="detail-info">
    <div class="container">
        <p class="title text-center">
            {{ 'IRONSIDE.tabview-product.PRODUCT_INFORMATION' | translate }}
        </p>
        <ng-container *ngIf="isPermissionAllExport">
            <app-export-data-product
                #exportDataProduct
                [height]="getHeight()"
                [products]="[productExtendInfo]"
                [idParentProduct]="idProduct"
                [idProductSelected]="selectedChild"
                [exportOption]="exportOption"
            ></app-export-data-product>
        </ng-container>
        <div class="wrap-tab-info" #tableInformationProduct>
            <p-tabView [scrollable]="true" #tableInformationProduct>
                <p-tabPanel
                    header="{{ 'IRONSIDE.tabview-product.PRODUCT_CHARACTERISTICS' | translate }}"
                >
                    <div class="tab-content">
                        <div class="table-product">
                            <table>
                                <thead>
                                    <tr>
                                        <th *ngIf="isPermissionAllExport">
                                            <mat-checkbox
                                                [checked]="isAllSelected(productExtendInfo ?? [])"
                                                [indeterminate]="
                                                    isIndeterminate(productExtendInfo ?? [])
                                                "
                                                (change)="
                                                    toggleSelectAll(
                                                        $event.checked,
                                                        productExtendInfo ?? []
                                                    )
                                                "
                                                (click)="$event.stopPropagation()"
                                            >
                                            </mat-checkbox>
                                        </th>
                                        <th></th>
                                        <th>
                                            {{ 'IRONSIDE.tabview-product.REF_EAN' | translate }}
                                        </th>

                                        <th>
                                            {{
                                                'IRONSIDE.tabview-product.SPECIFICATIONS'
                                                    | translate
                                            }}
                                        </th>

                                        <th>
                                            {{ 'IRONSIDE.product-list.dimensions' | translate }}
                                        </th>

                                        <th>
                                            {{ 'IRONSIDE.product-list.weight-kg' | translate }}
                                        </th>

                                        <th
                                            *ngIf="
                                                permissionService.isPermissionFonction(
                                                    'visibilite-tarifs'
                                                )
                                            "
                                        >
                                            {{ 'IRONSIDE.product-list.prices' | translate }}
                                        </th>

                                        <th *ngIf="getAdditionalInformationColumn">
                                            {{
                                                'IRONSIDE.tabview-product.ADDITIONAL_INFORMATION'
                                                    | translate
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let info of productExtendInfo; let i = index">
                                        <td *ngIf="isPermissionAllExport">
                                            <mat-checkbox
                                                [checked]="isChildSelected(info.id ?? '')"
                                                (change)="
                                                    toggleChildSelection($event.checked, info)
                                                "
                                            ></mat-checkbox>
                                        </td>
                                        <td>
                                            <ng-container
                                                *ngIf="isCurrentDateInRange(info) || info?.state"
                                            >
                                                <div class="section-tag">
                                                    <span
                                                        *ngIf="isCurrentDateInRange(info)"
                                                        class="new-tag"
                                                        >{{
                                                            'IRONSIDE.tabview-product.NEW'
                                                                | translate
                                                        }}</span
                                                    >
                                                    <span *ngIf="info?.state" class="state-tag">{{
                                                        info?.state?.labels
                                                            | translateDynamicLanguageTable
                                                            | uppercase
                                                    }}</span>
                                                </div>
                                            </ng-container>
                                        </td>

                                        <td>
                                            <strong style="display: block">{{
                                                info.refEan
                                            }}</strong>
                                            <strong>{{ info.gencodeProduct }}</strong>
                                            <span
                                                style="font-weight: 400"
                                                *ngIf="info.manufacturerReference"
                                                >{{ info.manufacturerReference }}</span
                                            >
                                        </td>

                                        <td>
                                            <span style="font-weight: 400">{{
                                                info.spec | translateDynamicLanguageTable
                                            }}</span>
                                        </td>

                                        <td class="truncate">
                                            <p style="font-weight: 400">
                                                {{
                                                    info.lengthProduct || 0
                                                        | translateDynamicLanguageTable
                                                }}
                                                <ng-container
                                                    *ngIf="
                                                        info.lengthProduct?.en_GB?.length ?? 0 > 0
                                                    "
                                                    >x</ng-container
                                                >
                                                {{
                                                    info.widthProduct || 0
                                                        | translateDynamicLanguageTable
                                                }}
                                                <ng-container
                                                    *ngIf="
                                                        info.widthProduct?.en_GB?.length ?? 0 > 0
                                                    "
                                                    >x</ng-container
                                                >
                                                {{
                                                    info.heightProduct || 0
                                                        | translateDynamicLanguageTable
                                                }}
                                            </p>
                                            <p
                                                style="font-weight: 400"
                                                *ngIf="hasBatteryValue(info)"
                                            >
                                                <strong
                                                    >{{
                                                        'IRONSIDE.tabview-product.BATTERY'
                                                            | translate
                                                    }}:
                                                </strong>
                                                {{ getBatteryValue(info) }}
                                            </p>
                                        </td>

                                        <td>
                                            <span style="font-weight: 400">
                                                {{ info?.weight ?? '-' }}
                                            </span>
                                        </td>

                                        <td
                                            *ngIf="
                                                permissionService.isPermissionFonction(
                                                    'visibilite-tarifs'
                                                )
                                            "
                                        >
                                            <div
                                                style="padding: 6px 0"
                                                *ngFor="
                                                    let prix of convertTariffs(info?.prixs);
                                                    let last = last
                                                "
                                                [ngClass]="{
                                                    'price-item':
                                                        !last && (info?.prixs?.length ?? 0) > 1
                                                }"
                                            >
                                                <ng-container *ngIf="prix[2] !== 'ARCHIVE'">
                                                    <span
                                                        class="truncate"
                                                        style="display: inline; margin-right: 6px"
                                                        >{{ prix[0] }}</span
                                                    >
                                                    <span
                                                        style="font-weight: 400; display: inline"
                                                        >{{ prix[1] }}</span
                                                    >
                                                    <div class="truncate">
                                                        {{ prix[2] }}
                                                    </div>
                                                    <div style="display: inline" *ngIf="prix[3]">
                                                        <a
                                                            style="
                                                                color: #434242;
                                                                text-decoration: none;
                                                                font-size: 12px;
                                                                cursor: pointer;
                                                                font-weight: 700;
                                                            "
                                                            (click)="
                                                                onRedirectToSupplier(
                                                                    prix[3]?.documentId
                                                                )
                                                            "
                                                            >{{ prix[3]?.value }}</a
                                                        >
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </td>

                                        <td *ngIf="hasAdditionalInformation(info)">
                                            <span
                                                *ngIf="info?.other"
                                                style="font-weight: 400; justify-content: center"
                                                >{{
                                                    info?.other | translateDynamicLanguageTable
                                                }}</span
                                            >
                                            <button
                                                [disabled]="dialogAdditionData.loading"
                                                class="btn-common btn-search"
                                                *ngIf="info?.associatedProduct"
                                                (click)="
                                                    onShowModalAddition(
                                                        info?.associatedProduct,
                                                        i,
                                                        'associated-products'
                                                    )
                                                "
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        dialogAdditionData?.loading &&
                                                            dialogAdditionData?.index === i &&
                                                            dialogAdditionData?.titleDialog ==
                                                                'associated-products';
                                                        else elseTemplate
                                                    "
                                                >
                                                    <mat-spinner [diameter]="15"></mat-spinner>
                                                </ng-container>
                                                <ng-template #elseTemplate>
                                                    {{
                                                        'IRONSIDE.tabview-product.associated-products'
                                                            | translate
                                                    }}
                                                </ng-template>
                                            </button>
                                            <button
                                                [disabled]="dialogAdditionData.loading"
                                                class="btn-common btn-search"
                                                *ngIf="info?.linkToTheReplacementArticle"
                                                (click)="
                                                    onShowModalAddition(
                                                        [info?.linkToTheReplacementArticle],
                                                        i,
                                                        'replacement-products'
                                                    )
                                                "
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        dialogAdditionData?.loading &&
                                                            dialogAdditionData?.index === i &&
                                                            dialogAdditionData?.titleDialog ==
                                                                'replacement-products';
                                                        else elseTemplate
                                                    "
                                                >
                                                    <mat-spinner [diameter]="15"></mat-spinner>
                                                </ng-container>
                                                <ng-template #elseTemplate>
                                                    {{
                                                        'IRONSIDE.tabview-product.replacement-products'
                                                            | translate
                                                    }}</ng-template
                                                >
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="{{ 'IRONSIDE.tabview-product.LOGISTICS' | translate }}">
                    <div class="tab-content">
                        <div class="table-product">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            {{ 'IRONSIDE.tabview-product.REF_EAN' | translate }}
                                        </th>
                                        <th>
                                            {{
                                                'IRONSIDE.tabview-product.SPECIFICATIONS'
                                                    | translate
                                            }}
                                        </th>
                                        <th>
                                            {{ 'IRONSIDE.product-list.dimensions' | translate }}
                                        </th>

                                        <th>
                                            {{ 'IRONSIDE.tabview-product.PACK_UNIT' | translate }}
                                        </th>
                                        <th>
                                            {{
                                                'IRONSIDE.tabview-product.CUSTOMS_CODE' | translate
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                'IRONSIDE.product-list.packaging'
                                                    | translate
                                                    | uppercase
                                                    | titlecase
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                'IRONSIDE.tabview-product.LOGISTICS_DATA'
                                                    | translate
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let info of productExtendInfo">
                                        <td>
                                            <strong style="display: block">{{
                                                info.refEan
                                            }}</strong>
                                            <strong>{{ info.gencodeProduct }}</strong>
                                            <span
                                                style="font-weight: 400"
                                                *ngIf="info.manufacturerReference"
                                                >{{ info.manufacturerReference }}</span
                                            >
                                        </td>
                                        <td>
                                            <span style="font-weight: 400">{{
                                                info.spec | translateDynamicLanguageTable
                                            }}</span>
                                        </td>
                                        <td class="truncate">
                                            <p style="font-weight: 400">
                                                {{
                                                    info.lengthProduct || 0
                                                        | translateDynamicLanguageTable
                                                }}
                                                <ng-container
                                                    *ngIf="
                                                        info.lengthProduct?.en_GB?.length ?? 0 > 0
                                                    "
                                                    >x</ng-container
                                                >
                                                {{
                                                    info.widthProduct || 0
                                                        | translateDynamicLanguageTable
                                                }}
                                                <ng-container
                                                    *ngIf="
                                                        info.widthProduct?.en_GB?.length ?? 0 > 0
                                                    "
                                                    >x</ng-container
                                                >
                                                {{
                                                    info.heightProduct || 0
                                                        | translateDynamicLanguageTable
                                                }}
                                            </p>
                                            <p
                                                style="font-weight: 400"
                                                *ngIf="hasBatteryValue(info)"
                                            >
                                                <strong
                                                    >{{
                                                        'IRONSIDE.tabview-product.BATTERY'
                                                            | translate
                                                    }}:
                                                </strong>
                                                {{ getBatteryValue(info) }}
                                            </p>
                                        </td>

                                        <td>
                                            <span style="font-weight: 400">
                                                {{ info.packSmallest?.conditioning ?? '-' }}
                                            </span>
                                        </td>
                                        <td>
                                            <span style="font-weight: 400">{{
                                                info.cutomsCode
                                            }}</span>
                                        </td>
                                        <td>
                                            <span style="font-weight: 400">{{
                                                info.packaging | translateDynamicLanguageTable
                                            }}</span>
                                        </td>
                                        <td>
                                            <button
                                                (click)="handleShowDialog(info)"
                                                class="btn-common comparer-btn"
                                            >
                                                {{
                                                    'IRONSIDE.tabview-product.SEE_MORE' | translate
                                                }}
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="{{ 'IRONSIDE.tabview-product.DOCUMENTS' | translate }}">
                    <div class="tab-content">
                        <div class="table-product">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            {{ 'IRONSIDE.tabview-product.REF_EAN' | translate }}
                                        </th>
                                        <th>
                                            {{
                                                'IRONSIDE.tabview-product.SPECIFICATIONS'
                                                    | translate
                                            }}
                                        </th>
                                        <th>
                                            {{ 'IRONSIDE.product-list.dimensions' | translate }}
                                        </th>
                                        <th>
                                            {{ 'IRONSIDE.tabview-product.DOCUMENTS' | translate }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngFor="let info of productExtendInfo; let i = index"
                                    >
                                        <tr *ngIf="info?.resources?.length ?? 0 > 0">
                                            <td>
                                                <strong style="display: block">{{
                                                    info.refEan
                                                }}</strong>
                                                <strong>{{ info.gencodeProduct }}</strong>
                                                <span
                                                    style="font-weight: 400"
                                                    *ngIf="info.manufacturerReference"
                                                    >{{ info.manufacturerReference }}</span
                                                >
                                            </td>
                                            <td>
                                                <span style="font-weight: 400">{{
                                                    info.spec | translateDynamicLanguageTable
                                                }}</span>
                                            </td>
                                            <td class="truncate">
                                                <p style="font-weight: 400">
                                                    {{
                                                        info.lengthProduct || 0
                                                            | translateDynamicLanguageTable
                                                    }}
                                                    <ng-container
                                                        *ngIf="
                                                            info.lengthProduct?.en_GB?.length ??
                                                            0 > 0
                                                        "
                                                        >x</ng-container
                                                    >
                                                    {{
                                                        info.widthProduct || 0
                                                            | translateDynamicLanguageTable
                                                    }}
                                                    <ng-container
                                                        *ngIf="
                                                            info.widthProduct?.en_GB?.length ??
                                                            0 > 0
                                                        "
                                                        >x</ng-container
                                                    >
                                                    {{
                                                        info.heightProduct || 0
                                                            | translateDynamicLanguageTable
                                                    }}
                                                </p>
                                                <p
                                                    style="font-weight: 400"
                                                    *ngIf="hasBatteryValue(info)"
                                                >
                                                    <strong
                                                        >{{
                                                            'IRONSIDE.tabview-product.BATTERY'
                                                                | translate
                                                        }}:
                                                    </strong>
                                                    {{ getBatteryValue(info) }}
                                                </p>
                                            </td>
                                            <td>
                                                <span
                                                    *ngFor="let resource of info?.resources"
                                                    (click)="onShowFile(resource)"
                                                    class="title-file-wrap"
                                                >
                                                    <span class="title-file-label"
                                                        >{{
                                                            resource?.typeOfResourceLabel
                                                                | translateDynamicLanguage
                                                        }}: </span
                                                    ><span class="title-file">
                                                        {{ resource?.title }}</span
                                                    >
                                                </span>
                                            </td>
                                            <!-- <td>
                                                <button
                                                    [disabled]="loading && indexLoading == i"
                                                    (click)="downloadAllResource(info, i)"
                                                    class="btn-common comparer-btn truncate"
                                                    style="
                                                        display: flex;
                                                        flex-direction: row;
                                                        gap: 4px;
                                                    "
                                                >
                                                    {{
                                                        'IRONSIDE.tabview-product.DOWNLOAD_ALL'
                                                            | translate
                                                    }}
                                                    <span
                                                        ><mat-spinner
                                                            *ngIf="loading && indexLoading == i"
                                                            [diameter]="20"
                                                        ></mat-spinner
                                                    ></span>
                                                </button>
                                            </td> -->
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
</div>
<div *ngIf="selectedInfo" class="wrap-p-dialog detail-product">
    <p-dialog [(visible)]="showDialog" [modal]="true" [styleClass]="'detail-product-dialog'">
        <ng-template pTemplate="header">{{
            'IRONSIDE.tabview-product.LOGISTICS_DATA' | translate
        }}</ng-template>
        <div class="inner-cnt">
            <div class="Country-infor">
                {{ 'IRONSIDE.tabview-product.COUNTRY_OF_ORIGIN' | translate }}:
                {{ selectedInfo.countryOfManufacture | translateDynamicLanguage }} <br />
                {{ 'IRONSIDE.tabview-product.CODE' | translate }}: {{ selectedInfo.cutomsCode }}
            </div>
            <div
                [ngStyle]="{
                    'grid-template-columns':
                        selectedInfo.logistics && selectedInfo.logistics.length > 4
                            ? 'repeat(4, 1fr)'
                            : 'repeat(' + selectedInfo?.logistics?.length + ', 1fr)'
                }"
                class="wrap-logistiques-item"
            >
                <div *ngFor="let item of selectedInfo.logistics" class="logistiques-item">
                    <div class="logistiques-title">
                        {{ item.typeOfVl | translateDynamicLanguage }}
                    </div>

                    <span
                        >{{ 'IRONSIDE.tabview-product.EAN' | translate }}:
                        {{ item.gencodeProduct }}</span
                    >
                    <span *ngIf="item.conditioning != null"
                        >{{ 'IRONSIDE.tabview-product.QUANTITY' | translate }}:
                        {{ item.conditioning }}</span
                    >
                    <span
                        >{{ 'IRONSIDE.tabview-product.HEIGHT_MM' | translate }} :
                        {{ item.height }}</span
                    >
                    <span
                        >{{ 'IRONSIDE.tabview-product.WIDTH_MM' | translate }}:
                        {{ item.width }}</span
                    >
                    <span
                        >{{ 'IRONSIDE.tabview-product.DEPTH_MM' | translate }} :{{
                            item.depth
                        }}</span
                    >
                    <span
                        >{{ 'IRONSIDE.tabview-product.NET_WEIGHT_KG' | translate }} :
                        {{ item.weight }}</span
                    >
                    <span
                        >{{ 'IRONSIDE.tabview-product.GROSS_WEIGHT_KG' | translate }} :
                        {{ item.grossWeight }}</span
                    >
                </div>
            </div>
        </div>
        <!-- <ng-template pTemplate="footer">
            <div class="d-flex justify-content-between">
                <button class="btn-custom ANNULER" (click)="closeDialog()">
                    {{ 'IRONSIDE.tabview-product.CANCEL' | translate }}
                </button>
                <button class="btn-custom VALIDER" (click)="closeDialog()">
                    {{ 'IRONSIDE.tabview-product.VALIDATE' | translate }}
                </button>
            </div>
        </ng-template> -->
    </p-dialog>
</div>

<p-dialog
    header="{{ 'IRONSIDE.news-detail-dialog.FILE_PREVIEW' | translate }}"
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: '50%' }"
    [draggable]="false"
>
    <div class="popup-del-row">
        <div class="w-100 text-end btn-download-file">
            <a
                (click)="
                    downloadFile(fileSelected.url, fileSelected?.fileName, fileSelected?.origin)
                "
                class="btn-common p-2"
                style="display: flex; flex-direction: row; gap: 4px; width: fit-content"
                >{{ 'IRONSIDE.news-detail-dialog.DOWNLOAD' | translate }}
                <span><mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner></span
            ></a>
        </div>
        <div id="outerContainer" *ngIf="fileSelected.url" class="pdf-viewer-container">
            <div class="pdf-container" [ngClass]="{ loaded: pdfLoaded }">
                <span [ngSwitch]="fileSelected?.type">
                    <p *ngSwitchCase="'pdf'">
                        <pdf-viewer
                            [src]="fileSelected.url || defaultImg"
                            [rotation]="0"
                            [original-size]="false"
                            [show-all]="true"
                            [fit-to-page]="false"
                            [zoom]="1"
                            [zoom-scale]="'page-width'"
                            [stick-to-page]="false"
                            [render-text]="true"
                            [external-link-target]="'blank'"
                            [autoresize]="true"
                            [show-borders]="false"
                            style="max-width: 100; width: 102%; height: 80vh; max-height: 500px"
                            (page-rendered)="pageRendered($event)"
                            (after-load-complete)="pageComplete($event)"
                        ></pdf-viewer>
                    </p>
                    <p *ngSwitchCase="'pptx'">
                        <iframe
                            [src]="sanitizedUrl(fileSelected.url)"
                            width="100%"
                            height="600px"
                            frameborder="0"
                        ></iframe>
                    </p>
                    <div *ngSwitchDefault style="width: 100%; text-align: center">
                        <img
                            [src]="fileSelected.url"
                            alt="img"
                            height="500"
                            style="object-fit: scale-down"
                        />
                    </div>
                </span>

                <div class="loading-file" *ngIf="loadingFile">
                    <mat-spinner [diameter]="50"></mat-spinner>
                </div>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog
    [header]="'IRONSIDE.tabview-product.' + dialogAdditionData.titleDialog | translate"
    [modal]="true"
    [(visible)]="dialogAdditionData.visible"
    [style]="{ width: '30rem' }"
>
    <ul>
        <li
            class="container-dialog-addition"
            style="cursor: pointer"
            *ngFor="let product of dialogAdditionData.data"
            (click)="onRedirectToProductDetail(product?.referenceParentProduct ?? '')"
        >
            <span>{{ product?.referenceProduct }}</span> -
            <span>{{ product?.shortDescription | translateDynamicLanguage }}</span>
        </li>
    </ul>
</p-dialog>
